import { render, staticRenderFns } from "./RecipeEdit.vue?vue&type=template&id=c5785932&scoped=true&"
import script from "./RecipeEdit.vue?vue&type=script&lang=js&"
export * from "./RecipeEdit.vue?vue&type=script&lang=js&"
import style0 from "./RecipeEdit.vue?vue&type=style&index=0&id=c5785932&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5785932",
  null
  
)

/* custom blocks */
import block0 from "./RecipeEdit.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports